import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "output", "chartContainer", "infiniteScrollContainer" ]
  static values = { assetId: String }

  connect() {
    // console.log("ActivityDisplayController connected");
    // By default, the daily output should be empty/hidden, and infinite scroll visible.
    this.outputTarget.hidden = true;
    if (this.hasInfiniteScrollContainerTarget) {
        this.infiniteScrollContainerTarget.hidden = false;
    }
  }

  async loadActivitiesForDay(event) {
    const date = event.currentTarget.dataset.activityDisplayDateValue;
    if (!date) {
      console.error("No date provided for loading activities.");
      return;
    }
    
    this.outputTarget.innerHTML = '<p class="text-center">Loading activities...</p>';
    this.outputTarget.hidden = false; // Show the daily activities output
    if (this.hasInfiniteScrollContainerTarget) {
      this.infiniteScrollContainerTarget.hidden = true; // Hide the main activities list
    }

    try {
      const url = `/assets/${this.assetIdValue}/day_activities_list?date=${date}`;
      const response = await fetch(url, {
        headers: {
          "Accept": "text/html",
          "X-Requested-With": "XMLHttpRequest"
        }
      });

      if (response.ok) {
        const htmlFragment = await response.text();
        this.outputTarget.innerHTML = htmlFragment;
      } else {
        console.error("Error loading daily activities:", response.status, response.statusText);
        this.outputTarget.innerHTML = '<p class="text-center text-danger">Could not load activities for this day. <button data-action="click->activity-display#showAllActivities" class="btn btn-sm btn-link">Show all</button></p>';
      }
    } catch (error) {
      console.error("Error fetching daily activities:", error);
      this.outputTarget.innerHTML = '<p class="text-center text-danger">An error occurred. <button data-action="click->activity-display#showAllActivities" class="btn btn-sm btn-link">Show all</button></p>';
    }
  }

  showAllActivities() {
    this.outputTarget.innerHTML = ''; // Clear daily activities
    this.outputTarget.hidden = true;  // Hide daily container
    if (this.hasInfiniteScrollContainerTarget) {
      this.infiniteScrollContainerTarget.hidden = false; // Show the main activities list
    }
  }
} 